<app-layout>
  <div class="main">
    <div class="header-table">
      <div class="title">
        <app-titulo>Parametrização da Tabela de Preços</app-titulo>
      </div>
      <div class="header-buttons">
        <app-botao
          type="primario"
          class="button"
          text="Cadastrar Precificação"
          icon="assets/add.svg"
          (click)="navegarPrecificacao()"></app-botao>
        <app-botao
          type="secundario"
          class="button"
          text="Exportar Excel"
          icon="assets/exportar-excel.svg"
          (click)="exportarExcel()"></app-botao>
      </div>
    </div>
    <div class="desktop grid-outline">
      <div class="grid-header">
        <div class="intern-title">Tabela de Preços<br /></div>
        <div class="align-button">
          <form [formGroup]="form">
            <div class="table-filters">
              <app-input
                type="select"
                width="200px"
                label="Serviço"
                name="FK_SRVC"
                formControlName="FK_SRVC"
                placeholder="Selecione"
                [selectData]="servicoOptions"
                (ngModelChange)="escolherServico($event)">
              </app-input>
              <app-input
                type="select"
                width="200px"
                label="Tipo da carreta"
                name="FK_TIPO_CRRT"
                formControlName="FK_TIPO_CRRT"
                placeholder="Selecione"
                [selectData]="tipoCarretaOptions"
                (ngModelChange)="escolherTipoCarreta($event)">
              </app-input>
              <app-input
                type="select"
                width="200px"
                label="Tipo da carga"
                placeholder="Pesquisar "
                name="FK_CRGA"
                formControlName="FK_CRGA"
                placeholder="Selecione"
                [selectData]="tipoCargaOptions"
                (ngModelChange)="escolherTipoCarga($event)">
              </app-input>
              <app-input
                type="select"
                width="200px"
                label="Status"
                placeholder="Pesquisar "
                name="NU_STTS_ALL"
                formControlName="NU_STTS_ALL"
                placeholder="Selecione"
                [selectData]="visualizarSuspensosOptions"
                (ngModelChange)="escolherVisualizarSuspensos($event)">
              </app-input>
            </div>
          </form>
        </div>
      </div>
      <app-loader [isLoading]="isLoading"></app-loader>
      <app-tabela
        *ngIf="!isLoading"
        [data]="tableData"
        [columns]="tableColumns"></app-tabela>
    </div>
  </div>
  <div class="mobile">
    <form [formGroup]="form" class="table-filters">
      <app-input
        type="select"
        width="200px"
        label="Serviço"
        name="FK_SRVC"
        formControlName="FK_SRVC"
        placeholder="Selecione"
        [selectData]="servicoOptions"
        (ngModelChange)="escolherServico($event)">
      </app-input>
      <app-input
        type="select"
        width="200px"
        label="Tipo da carreta"
        name="FK_TIPO_CRRT"
        formControlName="FK_TIPO_CRRT"
        placeholder="Selecione"
        [selectData]="tipoCarretaOptions"
        (ngModelChange)="escolherTipoCarreta($event)">
      </app-input>
      <app-input
        type="select"
        width="200px"
        label="Tipo da carga:"
        placeholder="Pesquisar "
        name="FK_CRGA"
        formControlName="FK_CRGA"
        placeholder="Selecione"
        [selectData]="tipoCargaOptions"
        (ngModelChange)="escolherTipoCarga($event)">
      </app-input>
    </form>
    <app-card
      *ngIf="!isLoading"
      [data]="tableData"
      [rows]="tableColumns"
      [expand]="true" />
  </div>
  <app-subtitulo *ngIf="!tableData.length"
    >Nenhum registro encontrado.</app-subtitulo
  >
  <div class="paginacao">
    <app-paginacao
      *ngIf="tableData.length"
      [pages]="maxPages"
      (selectedPage)="mudarPagina($event)"></app-paginacao>
  </div>
</app-layout>
